"use strict";
// Copyright © Veeam Software Group GmbH
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ChartLegend = exports.IDiv = exports.IRow = exports.IconTextAndChartRow = exports.PercentChartCell = exports.IconWithTextCell = exports.Cell = exports.WTr = exports.WTable = exports.WDiv = void 0;
const react_1 = __importDefault(require("react"));
const styled_components_1 = __importDefault(require("styled-components"));
const components_1 = require("@veeam/components");
const canceledLight32_svg_1 = __importDefault(require("../../assets/icons/dashboard/canceledLight32.svg"));
const components_2 = require("./..");
const Charts_1 = require("../Charts");
const UsageCellContent_1 = require("./UsageCellContent");
const constants_1 = require("./constants");
require("./types");
// Widget Div. Permanent constant height
exports.WDiv = styled_components_1.default.div `
  height: 300px;
  margin: 0 16px;
  overflow: hidden; //This is to hide the scrollbar in Firefox
`;
// Widget Table. Permanent height = 100%
exports.WTable = styled_components_1.default.table `
  height: ${(props) => (props.isShrink ? 'auto' : '100%')};
  width: 100%;
  border-collapse: collapse;
`;
// Widget Table Row
exports.WTr = styled_components_1.default.tr `
  border-top: ${(props) => props.borderTop};
  padding-top: ${(props) => props.paddingTop};
  &:hover {
    background-color: ${(props) => props.onClick ? props.theme.colors.backgrounds.selection : undefined};
    cursor: ${(props) => (props.onClick ? 'pointer' : 'default')};
  }
`;
exports.Cell = react_1.default.memo(({ width = '40%', height, borderRight, children }) => {
    return react_1.default.createElement("td", { style: { width, height, borderRight } }, children);
});
exports.IconWithTextCell = react_1.default.memo((_a) => {
    var { width, height, borderRight } = _a, iconWithTextProps = __rest(_a, ["width", "height", "borderRight"]);
    return (react_1.default.createElement(exports.Cell, { width: width, height: height, borderRight: borderRight },
        react_1.default.createElement(components_2.IconWithText, Object.assign({}, iconWithTextProps))));
});
exports.PercentChartCell = react_1.default.memo((chartProps) => {
    // todo: remove float
    return (react_1.default.createElement("td", { style: { width: '20%', textAlign: 'right' } },
        react_1.default.createElement("div", { style: { float: 'right' } },
            react_1.default.createElement(Charts_1.CircularChart, Object.assign({}, chartProps, { scale: 1 })))));
});
exports.IconTextAndChartRow = react_1.default.memo(({ icon, text, description, value, total, height, noDataText }) => {
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(exports.IconWithTextCell, { icon: icon, text: text, description: description, width: "40%" }),
        total ? (react_1.default.createElement(react_1.default.Fragment, null,
            react_1.default.createElement(exports.Cell, { height: height },
                react_1.default.createElement(UsageCellContent_1.UsageCellContent, { total: total, value: Number(value) })),
            react_1.default.createElement(exports.PercentChartCell, { value: Number(value), total: total, legendType: Charts_1.CHART_LEGEND_TYPE.percent }))) : (react_1.default.createElement(react_1.default.Fragment, null,
            react_1.default.createElement("td", { style: { height }, colSpan: 2 },
                react_1.default.createElement("div", { style: { display: 'flex', justifyContent: 'flex-end' } },
                    react_1.default.createElement(components_2.IconWithText, { icon: canceledLight32_svg_1.default, text: noDataText || '', view: components_1.TEXT_VIEW.primary })))))));
});
// Icon Row (in fact one or two rows dependent on height prop)
exports.IRow = styled_components_1.default.div `
  width: 100%;
  height: ${(props) => props.height}px;
`;
// Icon Div in storage icon row
// may be different width, have border on right side or not
exports.IDiv = styled_components_1.default.div `
  float: left;
  padding-top: ${(props) => { var _a; return (_a = props.paddingTop) !== null && _a !== void 0 ? _a : '8px'; }};
  box-sizing: border-box;
  width: ${(props) => props.width};
  border-right: ${(props) => (props.borderRight ? `1px solid ${constants_1.RowColors.separator}` : 'none')};
  height: ${(props) => props.height}px;
  padding-left: ${(props) => props.paddingLeft};
`;
const ChartLegend = ({ data }) => {
    return (react_1.default.createElement(components_2.TableKeyValue, { columnHorizontalGap: components_1.INDENT.m, columnVerticalGap: components_1.INDENT.m, items: data.map((v, idx) => {
            const colorIndex = Charts_1.calcColorIndex(idx, data.length, Charts_1.ChartColors.length);
            return {
                label: (react_1.default.createElement(components_1.StackView, { direction: components_1.STACK_DIRECTION.row, gap: components_1.STACK_GAP.s, align: components_1.STACK_ALIGN.center },
                    react_1.default.createElement("div", null,
                        react_1.default.createElement("svg", { width: 8, height: 8 },
                            react_1.default.createElement("circle", { cx: "4", cy: "4", r: "4", fill: Charts_1.ChartColors[colorIndex] }))),
                    react_1.default.createElement(components_1.Text, { weight: components_1.TEXT_WEIGHT.bold, size: components_1.TEXT_SIZE.m, whitespace: components_1.TEXT_WHITE_SPACE.nowrap }, v.text))),
                value: (react_1.default.createElement(components_1.Text, { weight: components_1.TEXT_WEIGHT.lighter, size: components_1.TEXT_SIZE.l, align: components_1.TEXT_ALIGN.right },
                    v.value,
                    " ",
                    v.suffix)),
                valueAlign: components_1.STACK_DISTRIBUTION.end,
            };
        }) }));
};
exports.ChartLegend = ChartLegend;
//# sourceMappingURL=components.js.map